/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-len */
ACC.newregisterpage = {
  signupError: 'signup__error',
  registerEmptyValue: 'register__emptyvalue',
  hideAfterCls: 'ph-hideAfter',
  hiddenCls: 'hidden',
  errorClass: 'form_field_error ph-form_field_error',
  accountNumberId: 'ph-commnumber',
  signUpErr: 'ph-signup__error',
  emptyVal: 'ph-register__emptyvalue',
  emptyContent: 'data-emptyContent',
  cityRegionError: $('#ph-cityRegionError').val(),
  streetnameError: $('#ph-streetnameError').val(),
  houseNumberError: $('#ph-houseNumberError').val(),
  addressGenericError: $('#ph-addressGenericError').val(),
  addressSuccessMsg: $('#ph-addressSuccessMsg').val(),
  optionPleaseSel: $('#ph-optionPleaseSel').val(),
  apiValidationError: 'apiValidationError',
  addressValidationEnabled: $('#addressValidationEnabled').val(),
  uploadedAttachement: [],
  fileListObject: [],
  fileListArray: [],
  uploadFileNameId: 'ph-upload-filename',
  fileUploadError: false,
  attachmentFileRow: '.ph-file-row',
  attachmentErrorMsg: '.ph-customerattachmeterrorshow',
  isEmptyValue: function(inputId) {
    var errormsgValue = $('#' + inputId).attr(ACC.newregisterpage.emptyContent),
        inputValue = '';

    if ($('#' + inputId).find('.form_field-input').has('input')) {
      inputValue = $('#' + inputId).find('input').val();
    } else if ($('#' + inputId).find('.form_field-input').has('select')) {
      inputValue = $('#' + inputId).find('option:selected').val();
    }

    if (inputValue === '' || inputValue === null || inputValue === 'undefined') {
      $('#' + inputId).find('.' + ACC.newregisterpage.signUpErr).addClass(ACC.newregisterpage.errorClass);
      $('#' + inputId).find('.' + ACC.newregisterpage.emptyVal).text(errormsgValue);
    } else {
      $('#' + inputId).find('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.errorClass);
      $('#' + inputId).find('.' + ACC.newregisterpage.emptyVal).text('');
    }
  },
  validateFields: function(inputIdName) {
    var selectedOption = $('input[name="philipsAccountNumber"]:checked').val();

    if (selectedOption === 'false' && inputIdName === ACC.newregisterpage.accountNumberId) {
      ACC.newregisterpage.isEmptyValue('invalid');
    } else if (selectedOption === 'true' && inputIdName === ACC.newregisterpage.accountNumberId) {
      ACC.newregisterpage.validateAccountNumber();
    } else {
      ACC.newregisterpage.isEmptyValue(inputIdName);
    }
  },
  validateAccountNumber: function() {
    var custAccNumber = $('input[name="custAccountNumber"]').val(),
        errormsgValue = $('#' + ACC.newregisterpage.accountNumberId).attr(ACC.newregisterpage.emptyContent),
        isValid = true;

    isValid = ACC.validation.customerAccountNumber(custAccNumber);

    if (isValid === true) {
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.signUpErr).addClass(ACC.newregisterpage.errorClass);
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.emptyVal).text(errormsgValue);
    } else {
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.errorClass);
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.emptyVal).text('');
    }
  },
  errorInfo: function(resthis) {
    var errormsgValue = $(resthis).parents('.ph-' + ACC.newregisterpage.signupError).parent().attr('data-emptyContent');

    $(resthis).parents('.ph-' + ACC.newregisterpage.signupError).addClass('form_field_error ph-form_field_error');
    $(resthis).parents('.ph-' + ACC.newregisterpage.signupError).find('.ph-' + ACC.newregisterpage.registerEmptyValue).text(errormsgValue);
  },

  removeInfo: function(resthis) {
    $(resthis).parents('.ph-' + ACC.newregisterpage.signupError).removeClass('form_field_error ph-form_field_error');
    $(resthis).parents('.ph-' + ACC.newregisterpage.signupError).find('.ph-' + ACC.newregisterpage.registerEmptyValue).text('');
  },
  addRemove: function(perthis) {
    if ($(perthis).val() === '' || $(perthis).val() === null) {
      ACC.newregisterpage.errorInfo(perthis);
    } else {
      ACC.newregisterpage.removeInfo(perthis);
    }
  },
  updatefirstPrefillField: function(prefillthis, secprefillthis) {
    if (prefillthis.val() !== '') {
      secprefillthis.val(prefillthis.val());
      ACC.newregisterpage.removeInfo(secprefillthis);
    }
  },
  updateSecPrefillField: function(prefillthis, secprefillthis) {
    if (secprefillthis.val() !== '') {
      prefillthis.val(secprefillthis.val());
      ACC.newregisterpage.removeInfo(prefillthis);
    }
  },
  accountNumChange: function(selectedOption) {
    var custAccountNumberId = '#ph-custAccountNumber';

    if (selectedOption === 'true') {
      $(custAccountNumberId).removeClass(ACC.newregisterpage.hiddenCls);
      $('.ph-organisationinfo').addClass(ACC.newregisterpage.hiddenCls);
      $('.ph-customerinfo').addClass(ACC.newregisterpage.hideAfterCls);
      $('.ph-yesForAccflow').removeClass(ACC.newregisterpage.hiddenCls);
      $('.ph-noForAccflow').addClass(ACC.newregisterpage.hiddenCls);
      $('.ph-businessTypeOther').addClass(ACC.newregisterpage.hiddenCls);
      $('.ph-conditionalfields').addClass(ACC.newregisterpage.hiddenCls);
    } else {
      $(custAccountNumberId).addClass(ACC.newregisterpage.hiddenCls);
      $('.ph-organisationinfo').removeClass(ACC.newregisterpage.hiddenCls);
      $('.ph-customerinfo').removeClass(ACC.newregisterpage.hideAfterCls);
      $('.ph-yesForAccflow').addClass(ACC.newregisterpage.hiddenCls);
      $('.ph-noForAccflow').removeClass(ACC.newregisterpage.hiddenCls);
      $('.ph-businessTypeOther').addClass(ACC.newregisterpage.hiddenCls);
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.errorClass);
      $('#' + ACC.newregisterpage.accountNumberId).find('.' + ACC.newregisterpage.emptyVal).text('');
      $('input[name="custAccountNumber"]').val('');
      $('.ph-conditionalfields').removeClass(ACC.newregisterpage.hiddenCls);
    }
  },
  vatPropChange: function(selectedOption) {
    var vatCountryId = '#ph-vatCountry',
        vatNumberId = '#ph-vatNumber';

    if (selectedOption === 'true') {
      $(vatCountryId).removeClass(ACC.newregisterpage.hiddenCls);
      $(vatNumberId).removeClass(ACC.newregisterpage.hiddenCls);
    } else {
      $(vatCountryId).addClass(ACC.newregisterpage.hiddenCls);
      $(vatNumberId).addClass(ACC.newregisterpage.hiddenCls);
      $('select[name="vatCountry"]').val('');
      $('input[name="vatNumber"]').val('');
    }
  },
  updateValidation: function() {
    var $registerAttachmentField = $('.ph-register-attachmentsec:visible');

    $registerAttachmentField.removeClass(ACC.newregisterpage.errorClass);

    if ($registerAttachmentField.length > 0 &&
      $registerAttachmentField.find('.ph-reg-fileupload').attr('data-mandatory') === 'true' &&
      ACC.newregisterpage.uploadedAttachement.length === 0) {
      $registerAttachmentField.addClass(ACC.newregisterpage.errorClass);
    }

    $('.ph-nonorgtype .ph-commonfield:visible').each(function() {
      ACC.newregisterpage.commonValidationFunction($(this));
    });
  },
  firstMethod: function() {
    var voucherValue = $('#ph-voucherCode input').val(),
        vocherCodeId = $('#ph-voucherCode').attr('id'),
        vocherCodeRegexValue = $('#ph-voucherCode').data('regexcontent'),
        vocherCodeRegex = '',
        validatedreturnCode = '';

    ACC.newregisterpage.updateValidation();
    // eslint-disable-next-line no-ternary
    vocherCodeRegex = vocherCodeRegexValue === '' ? '' : new RegExp(vocherCodeRegexValue);

    if (voucherValue !== '' && voucherValue !== null) {
      if (vocherCodeRegex !== '' && vocherCodeRegex !== null && vocherCodeRegex.test(voucherValue)) {
        validatedreturnCode = ACC.newregisterpage.validateVoucherAccessCode(voucherValue, vocherCodeId);

        if (validatedreturnCode === false) {
          return false;
        }
      }
    }

    if ($('.ph-form_field_error:visible').length > 0) {
      return false;
    }

    location.hash = 'customerinfo';

    return true;
  },

  getStudentSchoolName: function(countryIso, regionIso) {
    $.ajax({
      type: 'POST',
      data: {
        countryIsoCode: countryIso,
        regionIsoCode: regionIso
      },
      cache: false,
      url: ACC.config.encodedContextPath + '/accountregistration/registration/getSchools',
      success: function(response) {
        var $studentSchoolName = $('select[name = "schoolName"]'),
            htmlcontent = '',
            item = 0,
            htmlOptions = [];

        $studentSchoolName.find('option').remove();

        if (response.length > 0) {
          /* eslint-disable guard-for-in */
          /* eslint-disable xss/no-mixed-html */
          for (item in response) {
            htmlcontent = '<option value="' + response[item].name + '">' + response[item].name + '</option>';
            htmlOptions[htmlOptions.length] = htmlcontent;
          }

          /* eslint-enable guard-for-in */
          $studentSchoolName.empty().append('<option value="" disabled="disabled" selected="selected">' + ACC.newregisterpage.optionPleaseSel + '</option>' + htmlOptions.join(''));
          /* eslint-enable xss/no-mixed-html */
        }
      }
    });
  },
  getStudentSchoolRegion: function(countryIso) {
    $.ajax({
      type: 'POST',
      data: {
        countryIsoCode: countryIso
      },
      cache: false,
      url: ACC.config.encodedContextPath + '/accountregistration/registration/getRegions',
      success: function(response) {
        var $studentStateSelect = $('select[name = "studentRegionIsoCode"]'),
            htmlcontent = '',
            item = 0,
            htmlOptions = [];

        $studentStateSelect.find('option').remove();

        if (response.length > 0) {
          /* eslint-disable guard-for-in */
          /* eslint-disable xss/no-mixed-html */
          for (item in response) {
            htmlcontent = '<option value="' + response[item].isocode + '">' + response[item].name + '</option>';
            htmlOptions[htmlOptions.length] = htmlcontent;
          }

          /* eslint-enable guard-for-in */
          $studentStateSelect.empty().append('<option value="" disabled="disabled" selected="selected">' + ACC.newregisterpage.optionPleaseSel + '</option>' + htmlOptions.join(''));
          /* eslint-enable xss/no-mixed-html */
        }
      }
    });
    $.ajax({
      type: 'POST',
      data: {
        countryIsoCode: countryIso
      },
      cache: false,
      url: ACC.config.encodedContextPath + '/accountregistration/registration/getActiveSchoolsRegions',
      success: function(response) {
        var $schoolStateSelect = $('select[name = "schoolRegionIsoCode"]'),
            htmlcontent = '',
            item = 0,
            htmlOptions = [];

        $schoolStateSelect.find('option').remove();

        if (response.length > 0) {
          /* eslint-disable guard-for-in */
        /* eslint-disable xss/no-mixed-html */
          for (item in response) {
            htmlcontent = '<option value="' + response[item].isocode + '">' + response[item].name + '</option>';
            htmlOptions[htmlOptions.length] = htmlcontent;
          }

          /* eslint-enable guard-for-in */
          $schoolStateSelect.empty().append('<option value="" disabled="disabled" selected="selected">' + ACC.newregisterpage.optionPleaseSel + '</option>' + htmlOptions.join(''));
          /* eslint-enable xss/no-mixed-html */
        }
      }
    });
  },
  validateVoucherAccessCode: function(vocherCodeVal, vocherCodeId) {
    var returnVal = '';

    $.ajax({
      type: 'POST',
      async: false,
      data: {
        voucherCode: vocherCodeVal
      },
      cache: false,
      url: ACC.config.encodedContextPath + '/accountregistration/registration/validate-voucher-code',
      success: function(response) {
        if (response === false) {
          $('#' + vocherCodeId).find('.ph-signup__error').addClass(ACC.newregisterpage.errorClass);
          $('#' + vocherCodeId).find('.ph-register__emptyvalue').text($('#' + vocherCodeId).attr('data-emptyContent'));
          returnVal = false;
        } else if (response === true) {
          $('#' + vocherCodeId).find('.ph-signup__error').removeClass(ACC.newregisterpage.errorClass);
          $('#' + vocherCodeId).find('.ph-register__emptyvalue').text('');
          returnVal = true;
        }
      }
    });

    return returnVal;
  },
  getCommonRegion: function(countryIso, commonRegionSelect) {
    var getRegionUrl = ACC.config.encodedContextPath + '/accountregistration/registration/getRegions';

    if ($('.otafields:visible').length > 0) {
      getRegionUrl = ACC.config.encodedContextPath + '/checkout/single/summary/getRegions';
    }

    $.ajax({
      type: 'POST',
      data: {
        countryIsoCode: countryIso
      },
      cache: false,
      url: getRegionUrl,
      success: function(response) {
        var $regionSelect = $(commonRegionSelect),
            htmlcontent = '',
            item = 0,
            htmlOptions = [];

        $regionSelect.find('option').remove();

        if (response.length > 0) {
          /* eslint-disable guard-for-in */
          /* eslint-disable xss/no-mixed-html */
          for (item in response) {
            htmlcontent = '<option value="' + response[item].isocode + '">' + response[item].name + '</option>';
            htmlOptions[htmlOptions.length] = htmlcontent;
          }

          /* eslint-enable guard-for-in */
          $regionSelect.empty().append('<option value="" disabled="disabled" selected="selected">' + ACC.newregisterpage.optionPleaseSel + '</option>' + htmlOptions.join(''));
          /* eslint-enable xss/no-mixed-html */
        }
      }
    });
  },
  getAddressValidationResponse: function(currentAddressSection, addressAllData, curAddSectionCls, commonErrorCont) {
    $.ajax({
      type: 'POST',
      data: {
        addressForm: JSON.stringify(addressAllData)
      },
      cache: false,
      dataType: 'json',
      url: ACC.config.encodedContextPath + '/accountregistration/registration/validate-address',
      success: function(response) {
        $(curAddSectionCls + '[name^=\'' + currentAddressSection + '.\']').parents('.ph-' + ACC.newregisterpage.signupError)
          .removeClass(ACC.newregisterpage.errorClass);
        $(curAddSectionCls + '[name^=\'' + currentAddressSection + '.\']').parents('.ph-' + ACC.newregisterpage.signupError)
          .find('.' + ACC.newregisterpage.emptyVal).text('');
        $('.' + commonErrorCont).addClass('hidden');

        if (response.errorKey !== null) {
          if (response.errorKey === 'genericError') {
            $(curAddSectionCls + '[name^=\'' + currentAddressSection + '.\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.countryIso\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .removeClass(ACC.newregisterpage.errorClass);
            $('.' + commonErrorCont).removeClass('hidden').addClass('ph-redError')
              .text(ACC.newregisterpage.addressGenericError);
          } else if (response.errorKey === 'townCity') {
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.townCity\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.townCity\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text(ACC.newregisterpage.cityRegionError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.regionIso\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.regionIso\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text(ACC.newregisterpage.cityRegionError);
          } else if (response.errorKey === 'streetName') {
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.streetName\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.streetName\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text(ACC.newregisterpage.streetnameError);
          } else if (response.errorKey === 'houseNumber') {
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.houseNumber\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.houseNumber\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text(ACC.newregisterpage.houseNumberError);
          } else if (response.errorKey === 'countryIso') {
            $(curAddSectionCls + '[name^=\'' + currentAddressSection + '.\']').parents('.ph-' + ACC.newregisterpage.signupError)
              .addClass(ACC.newregisterpage.errorClass + ' ' + ACC.newregisterpage.apiValidationError);
            $('.' + commonErrorCont).removeClass('hidden').addClass('ph-redError')
              .text(ACC.newregisterpage.addressGenericError);
          }

          $('.ph-newregistration__btn').removeClass('ph-disableCommonBtn');
        } else if (response.fieldDetails.length > 0) {
          $.each(response.fieldDetails, function(index) {
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.' + response.fieldDetails[index].fieldName + '\']')
              .val(response.fieldDetails[index].fieldValue);
            $(curAddSectionCls + '[name=\'' + currentAddressSection + '.' + response.fieldDetails[index].fieldName + '\']')
              .parents('.ph-' + ACC.newregisterpage.signupError).find('.' + ACC.newregisterpage.emptyVal).addClass('ph-blueError')
              .text(ACC.newregisterpage.addressSuccessMsg);
          });

          if ($('.ph-form_field_error').length === 0) {
            $('.ph-newregistration__btn').removeClass('ph-disableCommonBtn');
          }
        } else if (response.errorKey === null && response.fieldDetails.length === 0) {
          $('.ph-newregistration__btn').removeClass('ph-disableCommonBtn');
        }
      }
    });
  },
  fileRestriction: function(file) {
    var isAllowed = 'true',
        sizeinBytes = parseInt($('.fileSizeinMb').val(), 10) * parseInt(1000000, 10),
        allowedTypes = [
          'image/jpeg',
          'application/pdf',
          'image/png'
        ];

    if (file.size === 0 || file.size > sizeinBytes) {
      isAllowed = 'false';
      ACC.newregisterpage.fileUploadError = 'size';
    }

    if (!allowedTypes.includes(file.type)) {
      isAllowed = 'false';
      ACC.newregisterpage.fileUploadError = 'type';
    }

    return isAllowed;
  },
  showFileTypeSizeError: function() {
    var errorMsg = $.trim($('.ph-fileSizeErrmsg').text());

    if (ACC.newregisterpage.fileUploadError === 'type') {
      errorMsg = $.trim($('.ph-fileTypeErrmsg').text());
      $(ACC.newregisterpage.attachmentErrorMsg).html(errorMsg).removeClass('hidden').show();
    } else if (ACC.newregisterpage.fileUploadError === 'size') {
      $(ACC.newregisterpage.attachmentErrorMsg).html(errorMsg).removeClass('hidden').show();
    } else {
      $(ACC.newregisterpage.attachmentErrorMsg).html('').addClass('hidden').hide();
    }

    ACC.newregisterpage.fileUploadError = false;
  },
  commonValidationFunction: function(ele) {
    var fieldValue = $(ele).val(),
        regexVal = $(ele).parents('.ph-' + ACC.newregisterpage.signupError).parent().attr('data-regexcontent'),
        emptyErrormsg = $(ele).parents('.ph-' + ACC.newregisterpage.signupError).parent().attr('data-emptyContent'),
        regexErrormsg = $(ele).parents('.ph-' + ACC.newregisterpage.signupError).parent().attr('data-regexError'),
        fieldRegex = '';

    if (regexVal !== '') {
      fieldRegex = new RegExp(regexVal);
    }

    if (!fieldValue && $(ele).attr('data-mandatory') === 'true') {
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).addClass(ACC.newregisterpage.errorClass);
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError')
        .text(emptyErrormsg);
    } else if (((regexVal !== '' && !fieldRegex.test(fieldValue)) && $(ele).attr('data-mandatory') === 'true') ||
    (fieldValue !== '' && regexVal !== '' && !fieldRegex.test(fieldValue))) {
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).addClass(ACC.newregisterpage.errorClass);
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError')
        .text(regexErrormsg);
    } else {
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).removeClass(ACC.newregisterpage.errorClass);
      $(ele).parents('.ph-' + ACC.newregisterpage.signupError).find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text('');
    }
  }
};
/* eslint-enable max-lines */
/* eslint-enable complexity */
/* eslint-enable max-statements */
/* eslint-disable  security/detect-unsafe-regex */
ACC.validation = {
  email: function(value) {
    var ckEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if (ckEmail.test(value)) {
      return false;
    }

    return true;
  },
  customerAccountNumber: function(accountNumber) {
    var numberRegex = /^\d{9,10}$/;

    if (numberRegex.test(accountNumber)) {
      return false;
    }

    return true;
  }
};
/* eslint-enable  security/detect-unsafe-regex */
/* eslint-disable max-statements */
$(document).ready(function() {
  var organisationinfoCls = '.ph-organisationinfo',
      customerinfoCls = '.ph-customerinfo',
      businessTypeOtherCls = '.ph-businessTypeOther',
      productCategoriesOtherCls = '.ph-productCategoriesOther',
      storeidvalue = $('.ph-storeid').val(),
      shortstoreidval = '',
      selectedOptAfterClick = $('input[name="philipsAccountNumber"]:checked').val(),
      languageIdvalue = $('.ph-languageId').val(),
      shippingAddresslistcheck = '.ph-shippingAddresslist',
      billingAddresslistcheck = '.ph-billingAddresslist',
      billingfieldcontainer = '.ph-billingfieldcont',
      deliveryfieldcontainer = '.ph-deliveryfieldcont',
      optinEloquaFieldsContainer = '.ph-optinEloquaFieldsCont',
      organisedPram = $('.ph-organiseParam').val(),
      firstNameInput = $('.ph-firstName').find('#ph-firstName'),
      lastNameInput = $('.ph-lastName').find('#ph-lastName'),
      phoneInput = $('.ph-phoneNumber').find('#ph-phoneNumber'),
      emailInput = $('.ph-emailAddress').find('#ph-emailAddress'),
      companyInput = $('.ph-companyName').find('#ph-companyName'),
      $countryInput = $('select[name="countryName"]'),
      secfirstNameInput = $('.ph-firstName2').find('#ph-firstName2'),
      seclastNameInput = $('.ph-lastName2').find('#ph-lastName2'),
      secphoneInput = $('.ph-phoneNumber2').find('#ph-phoneNumber2'),
      secemailInput = $('.ph-emailAddress2').find('#ph-emailAddress2'),
      seccompanyInput = $('.ph-companyName2').find('#ph-companyName2'),
      $seccountryInput = $('select[name="countryName2"]'),
      toolText = 'tool-tip-text';

  if ($('.pageLabel-newAccountRegisterPage').length > 0) {
    if (location.hash === '') {
      location.hash = 'personalinfo';
    }

    location.hash = 'personalinfo';
    document.documentElement.scrollTop = 0;

    if (organisedPram !== '' || organisedPram !== null) {
      $('select[name=\'businessType\'] option[value*=' + organisedPram + ']').prop('selected', true);
    }

    $('select[name="languageIsoCode"]').val(languageIdvalue);

    if (storeidvalue === 'us36-05') {
      shortstoreidval = 'CA';
    } else {
      shortstoreidval = storeidvalue.substring(0, 2).toUpperCase();
    }

    if (storeidvalue !== 'b2bwebshop') {
      $('select[name="countryName"]').val(shortstoreidval);
      $('select[name="countryName2"]').val(shortstoreidval);
      $('select[name="vatCountry"]').val(shortstoreidval);
      $('select[name="companyAddress.countryIso"]').val(shortstoreidval);
      $('select[name="billingAddressList[0].countryIso"]').val(shortstoreidval);
      $('select[name="shippingAddressList[0].countryIso"]').val(shortstoreidval);
    }

    $('.ph-updatecontryiso').val($('select[name="countryName2"]').val());

    $('input[name="companyAddress.streetName"]').addClass('ph-companyfields');
    $('input[name="companyAddress.houseNumber"]').addClass('ph-companyfields');
    $('input[name="companyAddress.townCity"]').addClass('ph-companyfields');
    $('input[name="companyAddress.postcode"]').addClass('ph-companyfields');
    $('select[name="companyAddress.countryIso"]').addClass('ph-companyfields');
    $('select[name="companyAddress.regionIso"]').addClass('ph-companyfields');

    $('input[name="billingAddressList[0].streetName"]').addClass('ph-billingfields');
    $('input[name="billingAddressList[0].houseNumber"]').addClass('ph-billingfields');
    $('input[name="billingAddressList[0].townCity"]').addClass('ph-billingfields');
    $('input[name="billingAddressList[0].postcode"]').addClass('ph-billingfields');
    $('select[name="billingAddressList[0].countryIso"]').addClass('ph-billingfields');
    $('select[name="billingAddressList[0].regionIso"]').addClass('ph-billingfields');

    $('input[name="shippingAddressList[0].streetName"]').addClass('ph-shippingfields');
    $('input[name="shippingAddressList[0].houseNumber"]').addClass('ph-shippingfields');
    $('input[name="shippingAddressList[0].townCity"]').addClass('ph-shippingfields');
    $('input[name="shippingAddressList[0].postcode"]').addClass('ph-shippingfields');
    $('select[name="shippingAddressList[0].countryIso"]').addClass('ph-shippingfields');
    $('select[name="shippingAddressList[0].regionIso"]').addClass('ph-shippingfields');
  }

  if (location.hash.includes('#personalinfo')) {
    $(organisationinfoCls).removeClass(ACC.newregisterpage.hiddenCls);
    $(customerinfoCls).removeClass('ph-hideAfter');
  }

  $(document).on('mouseover', '.ph-tool-tip', function() {
    $(this).find('.ph-' + toolText).removeClass('hidden');
  });

  $(document).on('mouseleave', '.ph-tool-tip', function() {
    $(this).find('.ph-' + toolText).addClass('hidden');
  });

  if (location.hash.includes('#customerinfo')) {
    ACC.newregisterpage.firstMethod();
    ACC.newregisterpage.accountNumChange(selectedOptAfterClick);
  }

  $(document).on('click', '.ph-registration__nextbtncust', function(event) {
    var countrySecVal = $('select[name="countryName2"]').val();

    selectedOptAfterClick = $('input[name="philipsAccountNumber"]:checked').val();

    event.preventDefault();
    ACC.newregisterpage.firstMethod();
    ACC.newregisterpage.accountNumChange(selectedOptAfterClick);
    ACC.newregisterpage.getStudentSchoolRegion(countrySecVal);
  });

  $(document).on('blur', '.ph-nonorgtype input.ph-commonfield[type="text"]', function() {
    ACC.newregisterpage.commonValidationFunction($(this));
  });

  $(document).on('change', '#ph-philipsAccountNumber', function() {
    var selectedOption = $('input[name="philipsAccountNumber"]:checked').val();

    ACC.newregisterpage.accountNumChange(selectedOption);
  });
  $(document).on('change', '#ph-customerVatNumber', function() {
    var selectedOption = $('input[name="customerVatNumber"]:checked').val();

    ACC.newregisterpage.vatPropChange(selectedOption);
  });
  $(document).on('keyup', '.ph-firstName #ph-firstName', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField(firstNameInput, secfirstNameInput);
  });
  $(document).on('keyup', '.ph-firstName2 #ph-firstName2', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField(firstNameInput, secfirstNameInput);
  });
  $(document).on('keyup', '.ph-lastName #ph-lastName', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField(lastNameInput, seclastNameInput);
  });
  $(document).on('keyup', '.ph-lastName2 #ph-lastName2', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField(lastNameInput, seclastNameInput);
  });
  $(document).on('keyup', '.ph-phoneNumber #ph-phoneNumber', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField(phoneInput, secphoneInput);
  });
  $(document).on('keyup', '.ph-phoneNumber2 #ph-phoneNumber2', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField(phoneInput, secphoneInput);
  });
  $(document).on('keyup', '.ph-emailAddress #ph-emailAddress', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField(emailInput, secemailInput);
  });
  $(document).on('keyup', '.ph-emailAddress2 #ph-emailAddress2', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField(emailInput, secemailInput);
  });
  $(document).on('keyup', '.ph-companyName #ph-companyName', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField(companyInput, seccompanyInput);
  });
  $(document).on('keyup', '.ph-companyName2 #ph-companyName2', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField(companyInput, seccompanyInput);
  });
  $(document).on('change', 'select[name="countryName"]', function(event) {
    event.preventDefault();
    ACC.newregisterpage.updatefirstPrefillField($countryInput, $seccountryInput);
    $('.ph-updatecontryiso').val($(this).val());
  });
  $(document).on('change', 'select[name="countryName2"]', function(event) {
    var countryIso = $(this).val();

    event.preventDefault();
    ACC.newregisterpage.updateSecPrefillField($countryInput, $seccountryInput);
    $('.ph-updatecontryiso').val($(this).val());
    ACC.newregisterpage.getStudentSchoolRegion(countryIso);
  });
  $(document).on('change', 'select[name="companyAddress.countryIso"]', function(event) {
    var countryIso = $(this).val(),
        regionSelectContainer = 'select[name="companyAddress.regionIso"]';

    event.preventDefault();
    $(regionSelectContainer).val('');
    $('.ph-updatecompanycontryiso').val($(this).val());
    ACC.newregisterpage.getCommonRegion(countryIso, regionSelectContainer);
  });
  $(document).on('change', 'select[name="billingAddressList[0].countryIso"]', function(event) {
    var countryIso = $(this).val(),
        regionSelectContainer = 'select[name="billingAddressList[0].regionIso"]';

    event.preventDefault();
    $(regionSelectContainer).val('');
    $('.ph-updatebillingcontryiso').val($(this).val());
    ACC.newregisterpage.getCommonRegion(countryIso, regionSelectContainer);
  });
  $(document).on('change', 'select[name="shippingAddressList[0].countryIso"]', function(event) {
    var countryIso = $(this).val(),
        regionSelectContainer = 'select[name="shippingAddressList[0].regionIso"]';

    event.preventDefault();
    $(regionSelectContainer).val('');
    $('.ph-updateshippingcontryiso').val($(this).val());
    ACC.newregisterpage.getCommonRegion(countryIso, regionSelectContainer);
  });
  $(document).on('change', 'select[name="schoolRegionIsoCode"]', function(event) {
    var countryIso = $('select[name="countryName2"]').val(),
        regionIso = $(this).val();

    event.preventDefault();
    ACC.newregisterpage.getStudentSchoolName(countryIso, regionIso);
  });
  $(document).on('change', '.ph-companyfields', function() {
    var currentAddressSection = 'companyAddress',
        curAddSectionCls = '.ph-companyfields',
        commonCompanyErrorCont = 'ph-register_errorContainer',
        addressAllData = {},
        validationOk = true,
        fldName = '',
        fldVal = '';

    $(curAddSectionCls).parents('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.apiValidationError);
    $(curAddSectionCls).each(function() {
      fldName = $(this).attr('name');
      fldName = fldName.replace('companyAddress.', '');
      fldVal = $(this).val();

      if (!fldVal && $(this).attr('data-mandatory') === 'true') {
        validationOk = false;
      }

      addressAllData[fldName] = fldVal || '';
    });

    if (validationOk && ACC.newregisterpage.addressValidationEnabled === 'true') {
      $('.ph-newregistration__btn').addClass('ph-disableCommonBtn');
      ACC.newregisterpage.getAddressValidationResponse(currentAddressSection, addressAllData, curAddSectionCls, commonCompanyErrorCont);
    }
  });
  $(document).on('change', '.ph-billingfields', function() {
    var currentAddressSection = 'billingAddressList[0]',
        curAddSectionCls = '.ph-billingfields',
        commonBillErrorCont = 'ph-register_billErrorContainer',
        addressAllData = {},
        validationOk = true,
        fldName = '',
        fldVal = '';

    $(curAddSectionCls).parents('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.apiValidationError);
    $(curAddSectionCls).each(function() {
      fldName = $(this).attr('name');
      fldName = fldName.replace('billingAddressList[0].', '');
      fldVal = $(this).val();

      if (!fldVal && $(this).attr('data-mandatory') === 'true') {
        validationOk = false;
      }

      addressAllData[fldName] = fldVal || '';
    });

    if (validationOk && ACC.newregisterpage.addressValidationEnabled === 'true') {
      $('.ph-newregistration__btn').addClass('ph-disableCommonBtn');
      ACC.newregisterpage.getAddressValidationResponse(currentAddressSection, addressAllData, curAddSectionCls, commonBillErrorCont);
    }
  });
  $(document).on('change', '.ph-shippingfields', function() {
    var currentAddressSection = 'shippingAddressList[0]',
        curAddSectionCls = '.ph-shippingfields',
        commonShipErrorCont = 'ph-register_shipErrorContainer',
        addressAllData = {},
        validationOk = true,
        fldName = '',
        fldVal = '';

    $(curAddSectionCls).parents('.' + ACC.newregisterpage.signUpErr).removeClass(ACC.newregisterpage.apiValidationError);
    $(curAddSectionCls).each(function() {
      fldName = $(this).attr('name');
      fldName = fldName.replace('shippingAddressList[0].', '');
      fldVal = $(this).val();

      if (!fldVal && $(this).attr('data-mandatory') === 'true') {
        validationOk = false;
      }

      addressAllData[fldName] = fldVal || '';
    });

    if (validationOk && ACC.newregisterpage.addressValidationEnabled === 'true') {
      $('.ph-newregistration__btn').addClass('ph-disableCommonBtn');
      ACC.newregisterpage.getAddressValidationResponse(currentAddressSection, addressAllData, curAddSectionCls, commonShipErrorCont);
    }
  });
  $(document).on('click', '.ph-promotioncommunication', function() {
    if ($(this).is(':checked')) {
      $('.ph-promotioncommunication').val('true');
      $(optinEloquaFieldsContainer).removeClass('hidden');
    } else {
      $('.ph-promotioncommunication').val('false');
      $(optinEloquaFieldsContainer).addClass('hidden');
    }

    if ($(optinEloquaFieldsContainer).find('.optInSelectboxes:visible').length > 0) {
      $('.ph-optInSelectboxes_title').show();
    } else {
      $('.ph-optInSelectboxes_title').hide();
    }
  });

  $(document).on('click', '.ph-billingAddresslist', function() {
    if ($(this).is(':checked')) {
      $(billingAddresslistcheck).val('true');
      $(billingfieldcontainer).removeClass('hidden');
    } else {
      $(billingAddresslistcheck).val('false');
      $(billingfieldcontainer).addClass('hidden');
    }
  });

  $(document).on('click', '.ph-shippingAddresslist', function() {
    if ($(this).is(':checked')) {
      $(shippingAddresslistcheck).val('true');
      $(deliveryfieldcontainer).removeClass('hidden');
    } else {
      $(shippingAddresslistcheck).val('false');
      $(deliveryfieldcontainer).addClass('hidden');
    }
  });

  $(document).on('change', 'select[name="businessType"]', function() {
    if ($('#ph-businessType[name=\'businessType\']').val() === 'OTHER') {
      $(businessTypeOtherCls).removeClass(ACC.newregisterpage.hiddenCls);
    } else {
      $(businessTypeOtherCls).addClass(ACC.newregisterpage.hiddenCls);
    }
  });

  $(document).on('change', 'select[name="productCategories"]', function() {
    if ($('#ph-productCategories[name=\'productCategories\']').val() === 'OTHER') {
      $(productCategoriesOtherCls).removeClass(ACC.newregisterpage.hiddenCls);
    } else {
      $(productCategoriesOtherCls).addClass(ACC.newregisterpage.hiddenCls);
    }
  });

  $(document).on('click', '.ph-newregistration__btn', function() {
    $('.ph-interstitial-loader').removeClass('hidden');
    ACC.newregisterpage.updateValidation();

    $('.apiValidationError:visible').removeClass('ph-form_field_error');

    if ($('.ph-form_field_error:visible').length > 0) {
      $('.ph-interstitial-loader').addClass('hidden');

      return false;
    }

    $('#userRegistrationForm').submit();

    return true;
  });
  $(document).on('click', '.ph-registration__nextbtnorgantab', function() {
    var selectVatOptCheck = $('input[name="customerVatNumber"]:checked').val(),
        companycountryIso = $('select[name="companyAddress.countryIso"]').val(),
        companyregionSelectContainer = 'select[name="companyAddress.regionIso"]',
        billingcountryIso = $('select[name="billingAddressList[0].countryIso"]').val(),
        billingregionSelectContainer = 'select[name="billingAddressList[0].regionIso"]',
        shippingcountryIso = $('select[name="shippingAddressList[0].countryIso"]').val(),
        shippingregionSelectContainer = 'select[name="shippingAddressList[0].regionIso"]';


    ACC.newregisterpage.getCommonRegion(companycountryIso, companyregionSelectContainer);
    ACC.newregisterpage.getCommonRegion(billingcountryIso, billingregionSelectContainer);
    ACC.newregisterpage.getCommonRegion(shippingcountryIso, shippingregionSelectContainer);
    ACC.newregisterpage.updateValidation();

    if ($('.ph-form_field_error:visible').length > 0) {
      return false;
    }

    if ($('#ph-productCategories[name=\'productCategories\']').val() !== 'OTHER') {
      $('.ph-productCategoriesOther').addClass(ACC.newregisterpage.hiddenCls);
    }

    ACC.newregisterpage.vatPropChange(selectVatOptCheck);

    $('.ph-nonorgtype .ph-commonfield').each(function() {
      ACC.newregisterpage.removeInfo(this);
    });

    location.hash = 'organisationinfo';

    return true;
  });
  /* eslint-disable xss/no-mixed-html */
  $(document).on('change', '.ph-reg-fileupload', function(event) {
    var input = event.target,
        removeText = $('.ph-remove-text').val(),
        templateHtmlHistory = '',
        isAllowed = '',
        arrayIndexHistory = ACC.newregisterpage.uploadedAttachement.length,
        $registerAttachmentField = $('.ph-register-attachmentsec:visible');

    if (input.files.length > 0) {
      $.each(input.files, function(index, uploadedFilesReg) {
        var fileObject = {
          name: ''
        };

        isAllowed = ACC.newregisterpage.fileRestriction(uploadedFilesReg);

        if (ACC.newregisterpage.uploadedAttachement.length < parseInt($('.allowedAttachementCount').val(), 10) && isAllowed === 'true') {
          ACC.newregisterpage.uploadedAttachement.push({
            fileId: 'fileId' + arrayIndexHistory,
            file: uploadedFilesReg
          });
          arrayIndexHistory = arrayIndexHistory + 1;
          fileObject.name = uploadedFilesReg.name;
          ACC.newregisterpage.fileListObject.push(uploadedFilesReg);
          ACC.newregisterpage.fileListArray.push(fileObject);
        }
      });

      $.each(ACC.newregisterpage.fileListArray, function(indexer, uploadedFilesReg) {
        templateHtmlHistory = templateHtmlHistory + (
          '<div class="ph-col-12 ph-d-flex ph-col-12 ph-align-items-center ph-file-rows ph-file-row' + indexer + ' ">' +
          '<div class="ph-col-8 ph-filesec ph-float-left">' +
          '<span class="ph-fileicon ph-float-left"></span>' +
          '<span class="ph-filename">' + uploadedFilesReg.name + '</span></div>' +
          '<div class="ph-col-4 ph-p-0 ph-float-left ph-remove-file">' +
          '<span class="ph-remove-link ph-reg-removefile" data-index=' + indexer + '>' + removeText + '</span></div>' +
          '</div>'
        );
      });

      $('#' + ACC.newregisterpage.uploadFileNameId).html(templateHtmlHistory);

      if ($('.ph-file-rows').length > 0) {
        $('#' + ACC.newregisterpage.uploadFileNameId).show();
        $('.ph-attachment-btn').addClass('ph-disableCommonBtn');
      }

      ACC.newregisterpage.showFileTypeSizeError();
    }

    $registerAttachmentField.removeClass(ACC.newregisterpage.errorClass);
  });
  $(document).on('click', '.ph-reg-removefile', function() {
    var indexer = $(this).attr('data-index'),
        rowsLength = 0,
        ind = 0;

    $(ACC.newregisterpage.attachmentFileRow + indexer).remove();
    ACC.newregisterpage.fileListArray.splice(indexer, 1);

    rowsLength = $('.ph-file-rows').length;

    if (rowsLength === 0) {
      $('#' + ACC.newregisterpage.uploadFileNameId).hide();
      $(ACC.newregisterpage.attachmentErrorMsg).hide();
      ACC.newregisterpage.fileListArray = [];
      ACC.newregisterpage.uploadedAttachement = [];
    } else {
      for (ind; ind < ACC.newregisterpage.uploadedAttachement.length; ind = ind + 1) {
        if (ACC.newregisterpage.uploadedAttachement[ind].fileId === 'fileId' + indexer) {
          ACC.newregisterpage.uploadedAttachement.splice(ind, 1);
        }
      }
    }

    $('.ph-reg-fileupload').val('');
    $('.ph-attachment-btn').removeClass('ph-disableCommonBtn');
  });
  /* eslint-enable xss/no-mixed-html */
});
/* eslint-enable max-statements */
/* eslint-enable max-len */
